import * as React from 'react';
import { useEffect, useState } from 'react';
import { Pagination } from 'react-bootstrap';

interface Props {
  numeroTotalePagine: number | undefined
  paginaSelezionata: number
  isFirstPage: boolean
  isLastPage: boolean
  setPaginaSelezionata: (pagina: number) => void
  elencoRisultati: any[]
}

const PaginationComponent: React.VFC<Props> = (props: Props) => {

  const {
    numeroTotalePagine,
    paginaSelezionata,
    isFirstPage,
    isLastPage,
    setPaginaSelezionata,
    elencoRisultati
  } = props;

  const [pagination, setPagination] = useState<JSX.Element[]>([]);

  const setBackPage = () => {
    setPaginaSelezionata(paginaSelezionata - 1);
  }
  const setNextPage = () => {
    setPaginaSelezionata(paginaSelezionata + 1);
  }

  useEffect(() => {
    const items: JSX.Element[] = [];
    const offset = 3;

    if (numeroTotalePagine && numeroTotalePagine > 1) {

      if (numeroTotalePagine > 10) {
        items.push(<Pagination.First key={'pagination_first'} onClick={() => setPaginaSelezionata(1)} disabled={isFirstPage} />);
        items.push(<Pagination.Prev key={'pagination_-1'} onClick={setBackPage} disabled={isFirstPage} />);
        if (paginaSelezionata && paginaSelezionata > offset + 1) {
          items.push(<Pagination.Ellipsis key={'pagination_-ell'} onClick={() => setPaginaSelezionata(paginaSelezionata - offset - 1)} />);
        }
        const min = Math.max(1, paginaSelezionata - offset);
        for (let i = min; i < paginaSelezionata; i++) {
          items.push(
            <Pagination.Item key={'pagination_' + i} active={i === paginaSelezionata} onClick={() => setPaginaSelezionata(i)}>
              {i}
            </Pagination.Item>
          );
        }
        const max = Math.min(paginaSelezionata + offset, numeroTotalePagine);
        for (let i = paginaSelezionata; i <= max; i++) {
          items.push(
            <Pagination.Item key={'pagination_' + i} active={i === paginaSelezionata} onClick={() => setPaginaSelezionata(i)}>
              {i}
            </Pagination.Item>
          );
        }
        if (paginaSelezionata + offset < numeroTotalePagine) {
          items.push(<Pagination.Ellipsis key={'pagination_+ell'} onClick={() => setPaginaSelezionata(paginaSelezionata + offset + 1)} />);
        }
        items.push(<Pagination.Next key={'pagination_+1'} onClick={setNextPage} disabled={isLastPage} />);
        items.push(<Pagination.Last key={'pagination_last'} onClick={() => setPaginaSelezionata(numeroTotalePagine)} disabled={isLastPage} />);
      } else {
        items.push(<Pagination.Prev key={'pagination_-1'} onClick={setBackPage} disabled={isFirstPage} />);
        for (let i = 1; i <= numeroTotalePagine; i++) {
          items.push(
            <Pagination.Item key={'pagination_' + i} active={i === paginaSelezionata} onClick={() => setPaginaSelezionata(i)}>
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Next key={'pagination_+1'} onClick={setNextPage} disabled={isLastPage} />);
      }

    }

    setPagination(items);

  }, [elencoRisultati, paginaSelezionata]);

  return (
    <Pagination className='justify-content-center'>{pagination}</Pagination>
  );
}

export default PaginationComponent;
